import { render, staticRenderFns } from "./PagePlaceholder.vue?vue&type=template&id=0e76ad39&lang=pug"
import script from "./PagePlaceholder.vue?vue&type=script&lang=js"
export * from "./PagePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./PagePlaceholder.vue?vue&type=style&index=0&id=0e76ad39&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports